// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"106":"app/css/app","969":"app/css/theme"}[chunkId] + "." + __webpack_require__.h().slice(0, 6) + ".css";
};